import { Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IdentityService } from 'app/core/identity/identity.service';
import { SettingsService } from 'app/shared/services/admin-settings.service';

/** Admin-only while credit history is shorter than the Visits window. */
export function injectCreditedVisitsAccess(): Signal<boolean> {
  const identityService = inject(IdentityService);
  const settings = toSignal(inject(SettingsService).settings$, { initialValue: null });
  return computed(() => !!settings()?.adminToggle && !!identityService.currentIdentity?.isAdmin());
}
